import DS from 'ember-data';
import MF from 'ember-data-model-fragments';
import { readOnly, equal } from '@ember/object/computed';
import TourStepValidations from '../validators/tour-step';
const PROGRESSION_BEHAVIORS = {
  manual: 0,
  click: 1,
  type: 2,
  hover: 3
};
const PLACEMENTS = {
  auto: 0,
  top: 1,
  bottom: 2,
  right: 3,
  left: 4
};
export default DS.Model.extend(TourStepValidations, {
  tourId: DS.belongsTo('tour'),
  order: DS.attr('number'),
  url: DS.attr('string'),
  blocks: DS.attr(),
  selector: DS.attr('string'),
  selectors: MF.fragment('tour-step/selectors'),
  progressionBehavior: DS.attr('number', {
    defaultValue: PROGRESSION_BEHAVIORS.manual
  }),
  placement: DS.attr('number', {
    defaultValue: PLACEMENTS.auto
  }),
  pointerSize: DS.attr('number', {
    defaultValue: 0
  }),
  buttonText: DS.attr('string'),
  style: DS.attr('string'),
  urlButtonValue: DS.attr('string'),
  isPointer: equal('style', 'pointer'),
  isPost: equal('style', 'post'),
  isVideo: equal('style', 'video'),
  isManualProgress: equal('progressionBehavior', PROGRESSION_BEHAVIORS.manual),
  isClickToProgress: equal('progressionBehavior', PROGRESSION_BEHAVIORS.click),
  isTypeToProgress: equal('progressionBehavior', PROGRESSION_BEHAVIORS.type),
  isHoverToProgress: equal('progressionBehavior', PROGRESSION_BEHAVIORS.hover),
  hasSelector: readOnly('selectors.hasSelector')
});
export { PROGRESSION_BEHAVIORS };
export { PLACEMENTS };